import React from 'react';

import { Box } from '@clutter/clean';

export const Stack: React.FC<{ gap?: string; children: React.ReactNode }> = ({ gap = '8px', children }) => (
  <Box.Flex flexDirection="column" gap={gap}>
    {children}
  </Box.Flex>
);
